const elIsInView = (el: HTMLElement): boolean => {
  const rect = el.getBoundingClientRect();
  return (
    rect.top < rect.bottom &&
    rect.bottom > rect.top &&
    rect.left < rect.right &&
    rect.right > rect.left
  );
};


export default elIsInView;